import Barba from 'barba.js'

window.jQuery = window.$ = require('jquery')
const imagesLoaded = require('imagesloaded')
imagesLoaded.makeJQueryPlugin($)

/* eslint-disable no-unused-vars */
Barba.Pjax.Dom.wrapperId = 'js-pjax-wrapper'
Barba.Pjax.Dom.containerClass = 'js-pjax-container'

Barba.Pjax.start()
Barba.Prefetch.init()

const body = $('body')
const mask = $('#js-loader-mask')
const transitionLoader = $('#js-transition-loader')

var DefaultTransition = Barba.BaseTransition.extend({
  start: function() {
    Promise.all([this.newContainerLoading, this.PageLeave()]).then(this.PageEnter.bind(this))
  },

  PageLeave: function() {
    return $(this.oldContainer)
      .delay(1200)
      .animate({ opacity: 0 })
      .promise()
  },

  PageEnter: function() {
    const _this = this
    const $el = $(this.newContainer)

    $(this.oldContainer).hide()

    $el.css({
      visibility: 'visible',
      opacity: 0
    })

    $el.animate({ opacity: 1 }, 0, function() {
      _this.done()
    })
  }
})

Barba.Pjax.getTransition = function() {
  return DefaultTransition
}

Barba.Dispatcher.on('linkClicked', function(HTMLElement, MouseEvent) {
  body.removeClass('is-loaded').addClass('is-loading')
  transitionLoader.delay(800).fadeIn(500)
  mask.show().addClass('is-loading')
})

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container, newPageRawHTML) {
  if (Barba.HistoryManager.history.length === 1) {
    return
  }

  ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search)

  if (typeof twttr === 'undefined') {
    const twitterjs = document.createElement('script')
    twitterjs.async = true
    twitterjs.src = '//platform.twitter.com/widgets.js'
    document.getElementsByTagName('body')[0].appendChild(twitterjs)
  } else {
    twttr.widgets.load()
  }

  return false
})

Barba.Dispatcher.on('transitionCompleted', function(HTMLElement, MouseEvent) {
  $('#js-pjax-wrapper').imagesLoaded(() => {
    body.removeClass('is-loading').addClass('is-loaded')
    mask.removeClass('is-loading').addClass('is-loaded')

    transitionLoader.fadeOut(500)

    setTimeout(function() {
      mask.hide().removeClass('is-loaded')
    }, 1000)
  })

  $('.is-state-animation').css('visibility', 'hidden')

  if ($('.is-state-animation').hasClass('is-animated')) {
    $('.is-state-animation').removeClass('is-animated')
  }

  if ($('#js-header').hasClass('is-active')) {
    $('#js-header').removeClass('is-active')
  }

  $(function() {
    const ua = navigator.userAgent
    if (ua.indexOf('iPhone') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
      $('a[href^="tel:"]').css('pointer-events', 'auto')
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      $('a[href^="tel:"]').css('pointer-events', 'none')
    } else {
      $('a:not(.is-not-hover),.c-btn:not(.is-disabled)').addClass('is-state-hover')
      $('.c-btn a').removeClass('is-state-hover')
      $('a[href^="tel:"]').css('pointer-events', 'none')
      if ($('.is-state-hover').length) {
        $('.is-state-hover').hover(
          function() {
            $(this).addClass('is-hover')
          },
          function() {
            $(this).removeClass('is-hover')
          }
        )
      }
    }
  })

  $(function() {
    const gHeader = $('#js-global-header').height()

    function pagelink(heightnum) {
      const headerH = heightnum
      $('a[href^="#"]').click(function() {
        const href = $(this).attr('href')
        const target = $(href == '#' || href == '' ? 'body' : href)
        const position = target.offset().top - headerH

        $('html, body').animate({ scrollTop: position }, 800, 'swing')
        return false
      })
    }
    pagelink(gHeader)
  })

  const cursor = $('#js-cursor')

  $('a:not([href^="tel:"]),button,label,input[type="submit"]').on({
    mouseenter: function() {
      cursor.addClass('is-active')
    },
    mouseleave: function() {
      cursor.removeClass('is-active')
    }
  })

  var headerFixed = false
  if (location.hash) {
    var anchor = document.querySelector(location.hash)
    if (anchor) {
      var rect = anchor.getBoundingClientRect()
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (headerFixed) {
        var header = document.getElementById('js-global-header')
        if (header) {
          top = top - header.clientHeight
        }
      }
      var top = rect.top + scrollTop
      window.scrollTo(0, top - 80)
    } else {
      window.scrollTo(0, 1)
    }
  } else {
    window.scrollTo(0, 1)
  }
})

Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck
Barba.Pjax.preventCheck = function(evt, element) {
  if (element) {
    if (!element.getAttribute('href')) {
      return false
    }
    // 外部リンクはtarget="_blank"に
    var site_url = location.protocol + '//' + location.host
    if (!element.href.startsWith(site_url)) {
      element.setAttribute('target', '_blank')
      return false
    }
    // アンカーリンクであり同一ページでなければbarbaを有効に
    var url = location.protocol + '//' + location.host + location.pathname
    var extract_hash = element.href.replace(/#.*$/, '')
    if (element.href.startsWith(location.protocol + '//' + location.host)) {
      if (element.href.indexOf('#') > -1 && extract_hash != url) {
        return true
      }
    }
    // 拡張子が該当する場合はtarget="_blank"に
    if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(element.href.toLowerCase())) {
      element.setAttribute('target', '_blank')
      return false
    }

    if (!Barba.Pjax.originalPreventCheck(evt, element)) {
      return false
    }
    return true
  }
}

const home = Barba.BaseView.extend({
  namespace: 'home',
  onEnterCompleted: function() {
    const ww = $(window).width()
    if (ww < 1200) {
      const heroHeader = heroHeader || {}
      heroHeader.VIEW_HEIGHT = {
        init: function() {
          this.setParameters()
          this.setMvHeight()
          this.bind()
        },
        setParameters: function() {
          this.$window = $(window)
          this.$target = $('#js-main-visual')
        },
        bind: function() {
          var _self = this
          this.$window.on('resize', function() {
            _self.setMvHeight()
          })
        },
        setMvHeight: function() {
          this.$target.css('height', this.$window.height())
        }
      }

      heroHeader.VIEW_HEIGHT.init()
    }

    $('.is-home').addClass('is-located')
  }
})

home.init()

/* eslint-enable no-unused-vars */
